/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: '/teacher/dashboard',
    name: 'Home',
    slug: 'home',
    icon: 'HomeIcon',
  },
  {
    url: null,
    name: 'Students',
    icon: 'UserIcon',
    slug: 'teacher-students',
    submenu: [
      {
        url: '/teacher/students/add',
        name: 'Add Students',
        slug: 'add-students',
      },
      {
        url: '/teacher/students/view',
        name: 'View/Edit Students',
        slug: 'view-students',
      },
    ],
  },
  {
    url: '/teacher/vje/activity',
    name: 'Student Activity',
    slug: 'vje-student-activity',
    icon: 'EyeIcon',
  },
  {
    url: '/teacher/vje/settings',
    name: 'Settings',
    slug: 'vje-settings',
    icon: 'settings',
    iconType: 'svgSprite',
  },
  {
    url: '/teacher/help',
    slug: 'teacher-help',
    name: 'Help',
    icon: 'HelpCircleIcon',
    i18n: 'FAQ',
  },
  {
    url: '/teacher/make-suggestion',
    name: 'Make a Suggestion',
    slug: 'make-suggestion',
    icon: 'MessageSquareIcon',
  },
  {
    url: '/teacher/logout',
    name: 'Log Out',
    icon: 'LogOutIcon',
  },
];
